import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeSmallCtaSkeleton } from "./TypeSmallCta";

/**
 * Fields type definition for content type 'TypeCard'
 * @name TypeCardFields
 * @type {TypeCardFields}
 * @memberof TypeCard
 */
export interface TypeCardFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized true
     */
    header?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'headerIcon' (Header Icon)
     * @name Header Icon
     * @localized false
     */
    headerIcon?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'description' (Description)
     * @name Description
     * @localized true
     */
    description?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'image' (Image)
     * @name Image
     * @localized false
     */
    image?: EntryFieldTypes.AssetLink;
    /**
     * Field type definition for field 'cta' (CTA)
     * @name CTA
     * @localized true
     */
    cta?: EntryFieldTypes.EntryLink<TypeSmallCtaSkeleton>;
    /**
     * Field type definition for field 'shadowColor' (Shadow Color)
     * @name Shadow Color
     * @localized false
     */
    shadowColor?: EntryFieldTypes.Symbol<"blue" | "dark-blue" | "gold" | "green" | "light-blue" | "magenta" | "red" | "yellow">;
    /**
     * Field type definition for field 'tags' (Tags)
     * @name Tags
     * @localized true
     */
    tags?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>;
    /**
     * Field type definition for field 'categories' (Categories)
     * @name Categories
     * @localized true
     */
    categories?: EntryFieldTypes.Array<EntryFieldTypes.Symbol>;
}

/**
 * Entry skeleton type definition for content type 'card' (Card)
 * @name TypeCardSkeleton
 * @type {TypeCardSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-25T23:56:52.124Z
 * @version 49
 */
export type TypeCardSkeleton = EntrySkeletonType<TypeCardFields, "card">;
/**
 * Entry type definition for content type 'card' (Card)
 * @name TypeCard
 * @type {TypeCard}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-25T23:56:52.124Z
 * @version 49
 */
export type TypeCard<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeCardSkeleton, Modifiers, Locales>;

export function isTypeCard<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeCard<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'card'
}
